module.exports = __webpack_public_path__ + "img/bible.1846fd13.jpg";